import { Survey } from './survey.model';

// Socket updates carry only the volatile `current`/`projected` cost fields, so
// the nested `totalCost`/`cpi` objects must be deep-merged — a shallow spread
// would drop `launch`/`feasibilityCpi` that the initial load established.
export function mergeSurveyPatch(
  previous: Survey,
  patch: Partial<Survey> = {},
): Survey {
  return {
    ...previous,
    ...patch,
    totalCost: patch.totalCost
      ? { ...previous.totalCost, ...patch.totalCost }
      : previous.totalCost,
    cpi: patch.cpi ? { ...previous.cpi, ...patch.cpi } : previous.cpi,
  };
}

// Deep-merge the patch into the matching survey; non-matching surveys pass
// through untouched.
export function patchSurveyInList(
  surveys: Survey[],
  surveyId: number,
  patch: Partial<Survey>,
): Survey[] {
  return surveys.map((survey) =>
    survey.id !== surveyId ? survey : mergeSurveyPatch(survey, patch),
  );
}
